function getMockCallouts(campaignId) {
  {
    return {
      result: {
        callouts: {
          standardBusinessCards: { value: "12% OFF" }
        },
        skin: "standard"
      }
    };
  }
}
function isMockTenant(tenant) {
  return tenant === "mock";
}

export { getMockCallouts, isMockTenant };
//# sourceMappingURL=src-mock-mockData.js.map
